import { render, staticRenderFns } from "./ContactMethodEditor.vue?vue&type=template&id=3578c9cc&scoped=true"
import script from "./ContactMethodEditor.vue?vue&type=script&lang=ts"
export * from "./ContactMethodEditor.vue?vue&type=script&lang=ts"
import style0 from "./ContactMethodEditor.vue?vue&type=style&index=0&id=3578c9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578c9cc",
  null
  
)

export default component.exports